import { stripHTML } from "./stripHTML";

export const calculateReadingTime = (text) => {

    text = stripHTML(text?.trim());

    const wordsPerMinute = 200; // Average case.

    let result;
    let textLength = text.split(" ").length;

    if (textLength > 0){
        let value = Math.ceil(textLength / wordsPerMinute);
        result = `~${value} min read`;
    }
    
    return result;
};